module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-two"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" don’t often recognize the faces of the entities I encounter, but at times I have experienced a prickle of déjà vu, as if I might have glimpsed them in passing. I’m fortunate that in all my twenty-seven years, I’ve never lost anyone truly close to me. I do remember an encounter back in high school with the ghost of a teacher, though. Her name was Miss Compton and she’d been killed in a car crash over a holiday long weekend. When classes resumed the following Tuesday, I’d stayed late to work on a project and I saw her spirit hovering in the dusky hallway near my locker. The manifestation had caught me off guard because in life, Miss Compton had been so demure and unassuming. I hadn’t expected her to come back grasping and greedy, hungrily seeking what she could never have again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Somehow I managed to keep my poise as I grabbed my backpack and closed my locker. She trailed me down the long hallway and through the front door, her chill breath on my neck, her icy hands clutching at my clothes. It was a long time before the air around me warmed and I knew she’d dissolved back into the netherworld. After that I made sure I was safely away from school before twilight, which meant no extracurricular activities. No ball games, no parties, no prom. I couldn’t take the chance of running into Miss Compton again. I was too afraid she might somehow latch on to me and then my life would never again be my own.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I turned my attention back to the ghost in the restaurant. I recognized him, too, but I didn’t know him personally. I’d seen his picture on the front page of the")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Post and Courier")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" a few weeks ago. His name was Lincoln McCoy, a prominent Charleston businessman who’d slaughtered his wife and children one night and then shot himself in the head rather than surrender to the S.W.A.T. team that had surrounded his house.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The way he appeared to me now was quite ethereal, with no evidence of the wrongs he’d committed on himself or his family. Except for his eyes. They were dark and blazing, yet at the same time icy. As he peered at me across the restaurant, I saw a faint smile touch his ghostly features.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Instead of flinching or glancing away in fright, I stared right back at him. He’d drifted into the restaurant behind an elderly couple who were now waiting to be seated. As his eyes held mine, I pretended to look right through him, even going so far as to wave at an imaginary acquaintance.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The ghost glanced over his shoulder, and at that precise moment, a waitress saw my wave and lifted one finger, indicating she would be with me in a moment. I nodded, smiled and picked up my champagne glass as I turned back to the window. I didn’t look at the ghost again, but I felt his frigid presence a moment later as he glided past my table, still trailing the old couple.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I wondered why he had attached himself to that particular pair and if on some level they were aware of his presence. I wanted to warn them, but I couldn’t without giving myself away. And that was what ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" wanted. What he desperately craved. To be acknowledged by the living so that he could feel a part of our world again.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Hands steady, I paid my check and left the restaurant without looking back.")])]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('span', [_vm._v(" Once outside, I allowed myself to relax as I walked back along White Point Gardens, in no particular hurry to seek the sanctuary of my home. Whatever spirits had managed to slip through the veil at dusk were already among us and as long as I remained vigilant until the sun came up, I needn’t cower from the icy drafts and swirling gray forms.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The mist had thickened. The Civil War cannons and statues in the park were invisible from the walkway, the bandstand and live oaks nothing more than vague silhouettes. But I could smell the flowers, that luscious blend of what I had come to think of as the Charleston scent—magnolia, hyacinth and Confederate jasmine.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Somewhere in the darkness, a foghorn sounded and out in the harbor, a lighthouse flashed warnings to the cargo ships traversing the narrow channel between Sullivan’s Island and Fort Sumter. As I stopped to watch the light, an uneasy chill crept over me. Someone was behind me in the fog. I could hear the soft yet unmistakable clop of leather soles against the seawall.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The footfalls stopped suddenly and I turned with a breathless shiver. For a long moment, nothing happened and I began to think I might have imagined the sound. Then he emerged from the veil of mist, sending the blood out of my heart with a painful contraction.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Tall, broad-shouldered and dressed all in black, he might have stepped from the dreamy hinterland of some childhood fable. I could barely make out his features, but I knew instinctively that he was handsome and brooding. The way he carried himself, the almost painful glare of his eyes through the mist, sent icy needles stinging down my spine.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was no ghost, but dangerous to me nonetheless and so compelling I couldn’t tear my gaze away as he moved toward me. And now I could see water droplets glistening in his dark hair and the gleam of a silver chain tucked inside the collar of his dark shirt.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Behind him, translucent and hardly discernible from the mist, were two ghosts, that of a woman and a little girl. They were both looking at me, too, but I kept my gaze trained on the man.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Amelia Gray?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes?” Since my blog had become so popular, I was occasionally approached by strangers who recognized me from website photos or from the infamous ghost video. The South, particularly the Charleston area, was home to dozens of avid taphophiles, but I didn’t think this man was a fan or a fellow aficionado. His eyes were cold, his manner aloof. He had not sought me out to chitchat about headstones.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m John Devlin, Charleston P.D.” As he spoke, he hauled out his wallet and presented his ID and badge, which I obligingly glanced at even though my heart had started to beat an agonizing staccato.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A police detective!")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" This couldn’t be good.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Something terrible must have happened. My parents were getting on in years. What if one of them had had an accident or taken ill or…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Tamping down an unreasonable panic, I slipped my hands into the pockets of my trench coat. If something had happened to Mama or Papa, someone would have called. This wasn’t about them. This was about me.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I waited for an explanation as those lovely apparitions hovered protectively around John Devlin. From what I could see of the woman’s features, she’d been stunning, with high cheekbones and proudly flaring nostrils that suggested a Creole heritage. She wore a pretty summer dress that swirled like gossamer around her long, slender legs.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The child looked to have been four or five when she died. Dark curls framed her pale face as she floated at the man’s side, reaching out now and then to clutch at his leg or tap on his knee.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He seemed oblivious to their presence, though he was clearly haunted. It showed in his face, in the eyes that were as hooded as they were piercing, and I couldn’t help wondering about his relationship to the ghosts.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I kept my eyes focused on his face. He was watching me, too, with an air of suspicion and superiority that could make dealing with the police an unpleasant ordeal, even over something as trivial as a parking ticket.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “What do you want?” I asked, though I hadn’t meant for the query to sound so blunt. I’m not a confrontational person. Years of living with ghosts had whittled away my spontaneity, leaving me overly disciplined and reserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Devlin moved a step closer and my hands curled into fists inside my coat pockets. A thrill chased across my skull and I wanted to tell him to keep his distance, ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("don’t come any closer.")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I said nothing, of course, as I braced myself against the frigid breath of his phantoms.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “A mutual acquaintance suggested I get in touch with you,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And who would that be?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Camille Ashby. She thought you might be able to help me out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “With what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “A police matter.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Now I was more curious than cautious—which made me also foolish.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Dr. Camille Ashby was an administrator at Emerson University, an elite, private college with powerful alumni that included some of the most prominent lawyers, judges and businessmen in South Carolina. Recently, I’d accepted a commission to restore an old cemetery located on university property. One of Dr. Ashby’s stipulations was that I not post any pictures on my blog until the restoration was complete.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I understood her concern. The dismal condition of the graveyard wasn’t a favorable reflection on a university that espoused the traditions and ethics of the old South. As Benjamin Franklin had put it: ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("One can tell the morals of a culture by the way they treat their dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Indeed.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" What I didn’t yet know was why she’d sent John Devlin to find me.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I understand you’ve been working in Oak Grove Cemetery,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I suppressed a shudder.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Oak Grove was one of those rare graveyards that evoked uneasiness, that literally made my skin crawl. The only other time I’d experienced a similar sensation was while visiting a small cemetery in Kansas that had been dubbed one of the seven gateways to hell.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I adjusted my collar against the glacial prickles at my nape. “What’s this about?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He ignored my question and asked one of his own. “When was the last time you were there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “A few days ago.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Can you be more specific?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Last Friday.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Five days,” he murmured. “You’re sure about that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes, of course. A big storm blew in that night and it’s been raining off and on ever since. I’ve been waiting for the ground to dry out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Camille…Dr. Ashby said you’ve been photographing the graves.” He waited for my nod. “I’d like to take a look at those shots.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Something about his tone, about this whole conversation put me on the defensive. Or maybe it was his ghosts. “Can you tell me why? And I’d also like to know how you found me tonight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You mentioned your dinner plans to Dr. Ashby.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I may have named the restaurant, but I didn’t tell her I’d be taking an after-dinner stroll, because I didn’t know it myself at the time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Call that part a hunch,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A hunch…or had he followed me from the Pavilion?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Dr. Ashby has my number. Why didn’t you just call me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I tried that. No answer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Well, yes, there was that. I’d turned off my phone for the evening. Still, I didn’t like any of this. John Devlin was a haunted man and that made him a dangerous man in my world.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He was also persistent and perhaps intuitive, so the quicker I rid myself of him the better.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Why don’t you give me a call first thing in the morning?” I said in a brisk, dismissive tone. “I’m sure whatever it is can wait until then.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, I’m afraid it can’t. This has to be done tonight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I shivered at his foreboding tone. “How ominous-sounding. Well, you’ve certainly gone to a great deal of trouble to track me down, so I suppose you may as well tell me why.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His gaze swept the darkness behind me and I had to resist the urge to glance over my shoulder. “The rain uncovered a body in one of the old graves at Oak Grove.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It wasn’t unheard of for old bones to wash up over time, due to rotting coffins and eroding soil.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Do you mean skeletal remains?” I asked with some delicacy.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, I mean fresh remains. A homicide victim,” he replied bluntly. His gaze lit on my face, studying me intently as if gauging my reaction.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A homicide. In the cemetery where I’d been working alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “That’s why you want my photographs. You’re hoping they’ll help pinpoint how long the body has been there,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “If we’re lucky.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" This I understood and was only too happy to cooperate. “I use a digital camera, but I print out most of my shots. I happen to have some enlargements in my briefcase, if you’d care to follow me back to my car.” I nodded in the direction from which we’d both come. “I can email you the rest of the images as soon as I get home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Thanks. That would be helpful.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I started walking and he fell into step beside me.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “One other thing,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’m sure I don’t have to school you on cemetery protocol, but there are certain precautions that have to be taken when dealing with an old graveyard like Oak Grove. We wouldn’t want to inadvertently desecrate a burial site. Dr. Ashby mentioned something about unmarked graves.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “As you said, it’s an old cemetery. One of the sections is pre–Civil War. Over that much time, it’s not unusual for headstones to get moved or go missing altogether.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “How do you locate the graves when that happens?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Any number of ways, depending on whether cost is a factor—radar, resistivity, conductivity, magnetometry. Remote sensing methods are preferred because they’re noninvasive. As is grave dousing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Grave dousing. Is that anything like water witching?” His tone gave away his skepticism.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes, same principle. A Y-shaped rod or sometimes a pendulum is used to divine the location of a grave. It’s been roundly debunked in scientific circles, but believe it or not, I’ve seen it work.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’ll take your word for it.” He paused. “Dr. Ashby said you’d completed the preliminary mapping, so I assume you’ve already located the graves by one means or another.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Dr. Ashby is being optimistic. I have a lot more research to do before I’ll know where all the bodies are buried, so to speak.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He didn’t crack a smile at my feeble pun. “But you must have a general idea.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Something in his voice bothered me and I stopped walking to glance up at him. Earlier, I’d thought his dark good looks had an almost fallen angel quality, but now he appeared merely tough and persistent. “Why do I get the impression you’re not just asking for a copy of my map?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It would save us a lot of time and potentially some bad PR if we have an expert consultant on hand during the exhumation. We’ll pay you for your time, of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Since you’re dealing with an old grave, I suggest you contact the state archaeologist. Her name is Temple Lee. I used to work for her. You’ll be in good hands.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We’d be hard-pressed to get someone down here from Columbia tonight, and as I said, this can’t wait until morning. The minute that body was discovered, the clock started ticking. The sooner we get an ID, the greater our chances for a satisfactory resolution. Dr. Ashby seems to think your credentials will pacify the committee.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The committee?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Local preservationists, members of the Historical Society, fat-cat alumni. They’ve got enough clout to raise a real ruckus if we don’t handle this thing according to procedure. You know the cemetery and you know the rules. All you have to do is make sure we don’t step on any toes. So to speak.” This time, I did see a faint smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “And that’s it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “That’s it.” He glanced out over the water. “Once the fog lifts, we could get more rain. We need to get this thing done.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This thing done.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" What a portentous turn of phrase.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “As I said, we’ll pay you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It’s not that.” I didn’t like the idea of going out to Oak Grove after dark, but I also didn’t see how I could refuse. Civic duty notwithstanding, Camille Ashby currently controlled my purse strings. It was in my best interests to keep her happy. “I’m hardly dressed for the occasion, but I suppose if you think I can be of some help…”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I do. Let’s grab those photos and head on out there.” He took my elbow, as if to propel me forward before I could change my mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His touch was strangely magnetic. It both attracted and repelled me, and as I pulled away, I found myself dredging up my father’s third rule and silently repeating it like a mantra:")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Keep your distance from those who are haunted.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" Keep your distance from those who are haunted.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I’d rather drive myself, if you don’t mind.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He gave me a sidelong glance as we continued along the walkway. “Whatever you want. It’s your call.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" We fell silent as we walked back through the mist, the lights from the East Bay mansions softly illuminating the ghost child floating between us. I was careful not to touch her. Careful not to look down as I felt the chilly brush of her hand against my leg.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The woman trailed behind us. It was odd to me that the little girl seemed the more dominant of the two, and I wondered again about their relationship to Devlin.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" How long had they haunted him? Did he have a clue they were there? Had he experienced cold spots, electrical surges, inexplicable noises in the middle of the night?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Did he realize that his energy was slowly being drained away?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The subtle radiation of his body heat would be irresistible to the ghosts. Even I wasn’t entirely immune.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As we stepped into the haze of a streetlamp, I stole another glance. The illumination seemed to repel the ghosts and as they drifted away, I caught a fleeting glimpse—a remnant, nothing more—of the vital man John Devlin had once been.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He cocked his head, as unmindful of my scrutiny as he was of the entities. I thought at first he was listening to the distant wail of the foghorn, but then I realized the sound that had captured his attention was closer. A car alarm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Where are you parked?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Over…there.” I pointed in the direction of the alarm.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" We hurried across the damp parking lot and as we rounded a row of cars, I glanced anxiously down the line, spotting my silver SUV beneath a security light where I had left it. The back door was ajar and shattered glass sparkled on the wet pavement.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “That’s mine!” I started toward it.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He caught my arm. “Hold on…”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Several rows over, a car engine revved.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Wait here!” he said. “And don’t touch anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I tracked him as he wove through the glistening cars and only turned away when I’d lost sight of him and the sound of his footsteps faded. Then I walked over to the open back door of my vehicle and peered inside. Thankfully, I’d left my laptop and camera at home, and I had my phone and wallet on me. The only thing that seemed to be missing was my briefcase.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The sound of the engine grew louder and I glanced around just as a black car skidded around the corner. Headlights caught me in the face and for a split second, I froze. Then adrenaline shot through me and I dove between my vehicle and the next as the car sped by me.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Devlin appeared out of the mist just as I picked myself up off the pavement.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You okay? Did he hit you?” He sounded anxious, but his dark eyes gleamed with the thrill of the hunt.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, I’m fine. Just a little shaken up—”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He sprinted away, cutting through the rows of parked cars in a futile effort to head off the culprit before he could get away. I heard the whine of the motor and the squeal of tires as the driver stomped the accelerator and swerved into the street.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" My imagination and nerves being somewhat overly stimulated, I half expected to hear gunshots, but all was silent after the engine noise faded.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Devlin trotted toward me, phone pressed to his ear. He spoke rapidly, listened for a moment, then hung up. “Did you get a look at the driver?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, sorry. It happened too fast. What about you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Never got close enough. Couldn’t make out the tags, either.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Then you won’t be able to track him down, will you? And I’ll be stuck with all the damage.” I glanced forlornly at my broken window.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He gave me a strange look before turning toward my car. “Can you tell if anything is missing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “My briefcase is gone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It was in the back?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “In plain view?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Not exactly. It was behind the rear seat. You’d have to peer into the window to notice it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Anyone see you put it in there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I thought about it for a minute, then shrugged. “It’s possible. I spent the afternoon at the university library, so I suppose someone could have seen me toss it in when I left.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You came straight here?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No. I went home to shower and change first.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Did you take your briefcase inside?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I left it in the car. I don’t always take it out at home. There’s nothing valuable in it. Just work-related stuff.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Like photos of Oak Grove Cemetery?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I honestly hadn’t made that leap yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I suppose my real world instincts had been severely stunted by the solitude of my profession and avocation.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You don’t think this could be connected to the body found in the cemetery, do you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He didn’t answer. “You say you have other copies of the photographs?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Of course. I always store my digital images online. I’ve had too many hard drive crashes to leave anything to chance.” Shock was starting to set in and my disquiet now had very little to do with John Devlin’s ghosts. I could no longer see them. It was as if the negative energy surrounding my car had chased them deeper into the shadows. Or maybe they were being pulled back behind the veil. Whatever the reason, I knew they would eventually return. His warmth would lure them back because they couldn’t exist for long without him.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I wrapped my arms around my middle and shivered. “What should I do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We’ll get you a police report written up and you can file a claim with your insurance company.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, I mean…if this is somehow connected to a homicide, then the killer knows who I am. And if he did this to get his hands on those pictures, he’ll figure out soon enough that I have copies.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Then we’d better find him first,” said John Devlin.")])])])]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a42e56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_Two.vue
// module id = 81
// module chunks = 0